module.exports = {"RECEPTION_TITLE":"Inspections","RECEPTION_DETAIL_TITLE":"General Information","RECEPTION_DECLARANT":"Declarant","RECEPTION_CUSTOMER":"Customer","RECEPTION_BLOCK":"Block","RECEPTION_APARTMENT":"Apt N<sup>o</sup>","RECEPTION_STATUS":"Status","RECEPTION_REFERENCE":"Reference","RECEPTION_CREATED_INFO":"Created on: {date} by {creator}","RECEPTION_VIEW_PDF":"View PDF","RECEPTION_CHARACTER_PROBLEM":"Type of the request","RECEPTION_COMMENT":"Comment","RECEPTION_PHOTO":"Photo(s)","RECEPTION_NUMBER_OF_KO":"Number of KO items: {num}","RECEPTION_SEE_DETAILS":"(See details)"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/reception/reception.en.json
// module id = kSQr
// module chunks = 0